<template>
	<!-- <f7-page id="addMemberGroupMemberList"> -->

  <div class="page" id="memberDebtorList">
  <!--
    <bottom-toolbar></bottom-toolbar>
    <f7-toolbar class="memberListToolbar" style="bottom:44px;">
      <f7-link class="streammindContactListButton yellowButton okButtonMemberList" @click="goBack">OK</f7-link>
      <f7-link class="streammindContactListButton yellowButton" @click="cancel">Cancel</f7-link>
    </f7-toolbar>
  -->
    <div class="page-content">
      <div class="layoutTop"/>
      <!-- <f7-navbar title="My Members"></f7-navbar> -->
      <f7-searchbar class="search"
        cancel-link="Cancel"
        search-list="#add-member-group-member-list"
        :placeholder="$t('creation_forms.srch_in_list')">
      </f7-searchbar>
      <f7-list id="add-member-group-member-list" members>
        <f7-list-group v-for="(group, key) in this.memberAlphabetList" :key="key">
          <f7-list-item :title="key" group-title></f7-list-item>
          <li v-for="member in group" :checked="member.checked" @change="member.checked = $event.target.checked">
            <label class="label-checkbox item-content" v-bind:class="{disabled: member.groupLabel !== '' && member.groupId !== currentGroupId  && member.groupService === currentGroupService}">
              <!-- Checked by default -->
              <input class="inputMember" type="checkbox" name="addMemberGroupMemberListCheckbox" :value="member.id" v-model="memberSelected">
              <div class="item-media">
                <i class="icon icon-form-checkbox"></i>
              </div>
              <div class="item-inner">
                <div class="item-title-row">
                  <div class="item-title">
                    {{member.login}}
                    <div class="text" v-if="member.groupLabel !== '' && member.groupId !== currentGroupId && member.groupService === currentGroupService">
                      Already present in the group {{member.groupLabel}}
                    </div>
                  </div>
                </div>
              </div>
            </label>
          </li>
        </f7-list-group>
      </f7-list>
      <div class="row justify-content-start">
        <div class="offset-md-3 col-md-3">
          <button class="buttonWidth streammindContactListButton okButtonMemberList" @click="goBack">
            <span>{{ $t('common.ok') }}</span>
          </button>
        </div>
        <div class="col-md-3">
          <button class="buttonWidth streammindContactListButton" @click="cancel">
            <span>{{ $t('common.cncl')}}</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="toolbarPageBottomBlank"></div>
      </div>
      <div class="layoutBottomMemberList"></div>
      <!-- <f7-toolbar class="memberListToolbar">
        <f7-link class="streammindContactListButton yellowButton okButtonMemberList" @click="goBack">OK</f7-link>
        <f7-link class="streammindContactListButton yellowButton" @click="cancel">Cancel</f7-link>
      </f7-toolbar> -->
	<!-- </f7-page> -->
    </div>
  </div>
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'

export default {
  name: 'addMemberGroupMembersList',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data: () => {
    return {
      memberSelected: [],
      memberAlphabetList: [],
      tab: [],
      currentGroupId: '',
      currentGroupService: ''
    }
  },
  mounted () {
    this.currentGroupId = this.$settings.currentMemberGroup.id
    this.currentGroupService = this.$engine.user.currentService.id
    var membersGroupList = {}
    var idsMember = []
    for (var i = 0; i < this.$settings.currentAccount.notInGroup.length; i++) {
      var tab = this.$settings.currentAccount.notInGroup
      if (tab[i].type === '2' && !idsMember.includes(tab[i].id)) {
        idsMember.push(tab[i].id)
        var firstLetter = tab[i].login.substr(0, 1).toUpperCase()
        if (tab[i].active === '2') {
          if (!membersGroupList.hasOwnProperty(firstLetter)) {
            membersGroupList[firstLetter] = []
          }
          membersGroupList[firstLetter].push({login: tab[i].login, name: tab[i].name, id: tab[i].id, clearance_payments: tab[i]['Payments'], clearance_directDebit: tab[i]['Direct Debit'], clearance_directPayments: tab[i]['Direct Payments'], groupLabel: tab[i].inGroupLabel, groupId: tab[i].inGroupId, groupService: tab[i].inGroupService, checked: false})
          membersGroupList[firstLetter].sort()
        }
      }
    }
    this.memberAlphabetList = this.orderKeys(membersGroupList)
    this.memberSelected = []
  },
  created () {
  },
  methods: {
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    changeItem () {
      let that = this
      that.memberSelected = []
      this.Dom7('input[name=addMemberGroupMemberListCheckbox]:checked').each(function () {
        that.memberSelected.push(that.Dom7(this).val())
      })
      // this.$engine.services.payments.memberDebtorList = that.memberSelected
    },
    goBack () {
      // let tab = this.memberAlphabetList.map(member => { member.map(m => { return m }) })
      let tab = []
      for (var key in this.memberAlphabetList) {
        for (var k in this.memberAlphabetList[key]) {
          tab.push(this.memberAlphabetList[key][k])
        }
      }
      tab = tab.filter(user => { return user.checked === true })
      this.$engine.settings.set({addMemberGroupMemberSelected: this.memberSelected})
      this.$bus.emit('refresh-add-member-group-member-selected', tab)
      this.$f7.mainView.router.back()
    },
    cancel () {
      this.$f7.mainView.router.back()
    }
  }
}
</script>
<style scoped>

  .text{
    font-size:14px;
  }
  .buttonWidth {
    width: 100% !important;
  }
  @media (min-width: 993px) {
    .addGroupMemberGroupList {
      margin-left: 260px !important;
    }
  }
</style>
